// Where the welcome walkthrough is, kept in sessionStorage so it survives the page changes the
// tour itself makes (every page mounts its own layout).
const KEY = "usend-welcome-tour";
const listeners = new Set();

export function readTour() {
  try {
    return JSON.parse(sessionStorage.getItem(KEY)) || null;
  } catch (e) {
    return null;
  }
}

export function writeTour(state) {
  try {
    if (state) sessionStorage.setItem(KEY, JSON.stringify(state));
    else sessionStorage.removeItem(KEY);
  } catch (e) {
    // Private mode without storage: the tour still runs within this page.
  }
  listeners.forEach((fn) => fn(state));
}

export function subscribeTour(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
